<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="计划名称">
              <a-input placeholder="请输入计划名称" v-model="queryParam.planName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="enabled_status"
                placeholder="请选择计划状态"
                type="checkbox"
                v-model="queryParam.planStatus"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('巡检计划')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="planCycle" slot-scope="priority, record">
          <span v-if="record.planCycle=='0 0/15 * * * ?'">
            <a-tag color="#52c41a">15分钟</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0/30 * * * ?'">
            <a-tag color="#52c41a">30分钟</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/1 * * ?'">
            <a-tag color="#52c41a">1小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/2 * * ?'">
            <a-tag color="#52c41a">2小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/3 * * ?'">
            <a-tag color="#52c41a">3小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/4 * * ?'">
            <a-tag color="#52c41a">4小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/6 * * ?'">
            <a-tag color="#52c41a">6小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/8 * * ?'">
            <a-tag color="#52c41a">8小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/12 * * ?'">
            <a-tag color="#52c41a">12小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0/24 * * ?'">
            <a-tag color="#52c41a">24小时</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 * * ?'">
            <a-tag color="#52c41a">1天</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 * * 1'">
            <a-tag color="#52c41a">1周</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 1,15 * ?'">
            <a-tag color="#52c41a">半月</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 1 * ?'">
            <a-tag color="#52c41a">1月</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 1 */2 ?'">
            <a-tag color="#52c41a">2月</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 1 */3 ?'">
            <a-tag color="#52c41a">3月</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 1 */6 ?'">
            <a-tag color="#52c41a">半年</a-tag>
          </span>
          <span v-else-if="record.planCycle=='0 0 0 1 1 ?'">
            <a-tag color="#52c41a">1年</a-tag>
          </span>
          <span v-else-if="record.planCycleType=='2'">
            <a-tag color="#52c41a">每日&nbsp;{{ record.planCycle | planCycleFilter}}</a-tag>
          </span>
          <span v-else>
            <a-tag color="#f50">未知周期</a-tag>
          </span>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="record.planStatus == 0 || record.planStatus == 2" />
          <a @click="handlePublish(record)" v-if="record.planStatus == 0 || record.planStatus == 2">发布</a>
          <a-divider type="vertical" v-if="record.planStatus == 1" />
          <a @click="handleHangUp(record)" v-if="record.planStatus == 1">挂起</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <yw-artificial-patrol-plan-modal @ok="modalFormOk" ref="modalForm" />
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import YwArtificialPatrolPlanModal from './modules/YwArtificialPatrolPlanModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { postAction } from '@/api/manage'

  export default {
    name: "YwArtificialPatrolPlanList",
    mixins: [JeecgListMixin],
    components: {
      YwArtificialPatrolPlanModal
    },
    data () {
      return {
        description: '巡检计划管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '巡检计划名称',
            align: "center",
            sorter: true,
            dataIndex: 'planName'
          },
          {
            title: '计划周期',
            align: "center",
            dataIndex: 'planCycle',
            scopedSlots: { customRender: 'planCycle' },
          },
          {
            title: '计划状态',
            align: "center",
            dataIndex: 'planStatus_dictText'
          },
          {
            title: '计划类型',
            align: "center",
            dataIndex: 'planCycleType_dictText'
          },
          {
            title: '下次执行时间',
            align: "center",
            dataIndex: 'nextTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/device/patrol/ywArtificialPatrolPlan/list",
          delete: "/device/patrol/ywArtificialPatrolPlan/delete",
          deleteBatch: "/device/patrol/ywArtificialPatrolPlan/deleteBatch",
          exportXlsUrl: "/device/patrol/ywArtificialPatrolPlan/exportXls",
          importExcelUrl: "device/patrol/ywArtificialPatrolPlan/importExcel",
          publishUrl: "/device/patrol/ywArtificialPatrolPlan/publish",
          hangUpUrl: "/device/patrol/ywArtificialPatrolPlan/hangUp",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      handlePublish (row) {
        if (row.planStatus != 0 && row.planStatus != 2) {
          this.$message.error('该状态不允许发布,请确认状态是否合法.')
          return
        }
        //发布
        postAction(this.url.publishUrl, row).then(res => {
          if (res.success) {
            this.$message.success('智能巡检计划发布成功.')
            this.searchQuery()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      handleHangUp (row) {
        if (row.planStatus != 1) {
          this.$message.error('该状态不允许挂起,请确认状态是否合法.')
          return
        }
        //挂起
        postAction(this.url.hangUpUrl, row).then(res => {
          if (res.success) {
            this.$message.success('智能巡检计划停用成功.')
            this.searchQuery()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'planName', text: '巡检计划名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'planCycle', text: '计划周期', dictCode: '' })
        fieldList.push({ type: 'string', value: 'planStatus', text: '计划状态', dictCode: 'enabled_status' })
        fieldList.push({ type: 'string', value: 'planCycleType', text: '周期类型', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'nextTime', text: '下次执行时间' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>